import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: {
    type: 'panel'
  }
} satisfies RecursivePartial<ProductConfig['shippingMethods']>
